const feedback = (state= {status: {error:false, loading:false}}, action) => {
	switch(action.type) {
		case 'feedback/create/success': {
			return {...state, status: {error:false, loading: false}}
		}
		case 'feedback/create/error': {
			return {...state, status: {error:true, loading: false}}
			
		}
		case 'feedback/create/loading': {
			return {...state, status: {error:false, loading: true}}
		}
		default:
			return state
	}
}

export default feedback